import React, { useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { LoadingSpinner } from '@/components/LoadingSpinner';
import { LoginScreen } from './LoginScreen';

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const handleLoginSuccess = useCallback(async (user: any) => {
    setIsLoading(true);
    try {
      // You can integrate with your actual auth service here
      // For now, we'll just navigate to dashboard
      const from = location.state?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
    } catch (error) {
      console.error('Login error:', error);
    } finally {
      setIsLoading(false);
    }
  }, [navigate, location.state?.from?.pathname]);

  const handleForgotPassword = useCallback(() => {
    // Navigate to forgot password page
    navigate('/forgot-password');
  }, [navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <LoginScreen 
      onLoginSuccess={handleLoginSuccess}
      onForgotPassword={handleForgotPassword}
    />
  );
};
